<script>
import ModelEdit from '../models/edit-v2.vue';
import FormsModel from "@/components/forms/customer";

export default {
  extends: ModelEdit,
  page: {
    title: "Edit Customers",
  },
  props: {
    cardTitle: { default() { return this.lodash.startCase(this.$t('customers.singular')) } },
    resourceRoute: { default: 'customers' },
    modelVariable: { default: 'customer' },
    denyDelete: { type: Boolean, default: true },
    form: { default() { return FormsModel; } }
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('customers.plural'))
    }
  },
  mounted() {
    this.fetchModel();
  },
  computed: {
    items() {
      return [
        {
          text: this.lodash.upperFirst(this.$t('customers.plural')),
          href: "/customers",
        },
        {
          text: this.model && this.model.id ? this.model['name'] : this.$route.params.key,
          href: `/customers/${this.$route.params.key}`,
          active: true,
        },
        {
          text: this.$t('Edit'),
          href: `/customers/${this.$route.params.key}/edit`,
          active: true,
        },
      ]
    }
  },
  methods: {
    fetchFarm(farm) {
      return this.$axios.get(`/jala/farms/${farm.jala_farm_id}`).then((response) => {
        const { data: { data } } = response;
        return {
          ...data,
          ...farm,
          region_id: farm.region_id ? farm.region_id.toString() : null,
          get coordinate() {
            return farm.latitude ? `${farm.latitude},${farm.longitude}` : null;
          },
          set coordinate(value) {
            if (value) {
              const [lat, lng] = (value || '').split(',');
              if (lat != null && Number(lat) && lng != null && Number(lng)) {
                data.latitude = Number(lat);
                data.longitude = Number(lng);
              }
            } else {
              data.latitude = null;
              data.longitude = null;
            }
          },
        }
        // return data;
      }).catch((error) => this.failedAlert(error));
    },
    async fetchModel() {
      try {
        this.loading = true;
        const response = await this.$axios.get(`/customers/${this.$route.params.key}`, {
          params: {
            with: 'bank_accounts.bank,farms,addresses'
          }
        });
        const { data: { data } } = response;
        const farmResponses = await Promise.all(data.farms.map(farm => (this.fetchFarm(farm))));
        // const addresses = data.addresses.map((address) => ({
        //   ...address,
        //   region_id: address.region_id ? address.region_id.toString() : null,
        //   get coordinate() {
        //     return address.latitude ? `${address.latitude},${address.longitude}` : null;
        //   },
        //   set coordinate(value) {
        //     if (value) {
        //       const [lat, lng] = (value || '').split(',');
        //       if (lat != null && Number(lat) && lng != null && Number(lng)) {
        //         address.latitude = Number(lat);
        //         address.longitude = Number(lng);
        //       }
        //     } else {
        //       address.latitude = null;
        //       address.longitude = null;
        //     }
        //   },
        // }))
        const addresses = {};
        ['lcs', 'brs', 'processing'].map((customer_type) => {
          const address = data.addresses.find((item) => item.type == customer_type) || {}
          addresses[customer_type] = {
            latitude: null,
            longitude: null,
            total_person: null,
            ...address,
            get coordinate() {
              return address.latitude ? `${address.latitude},${address.longitude}` : null;
            },
            set coordinate(value) {
              if (value) {
                const [lat, lng] = (value || '').split(',');
                if (lat != null && Number(lat) && lng != null && Number(lng)) {
                  address.latitude = Number(lat);
                  address.longitude = Number(lng);
                }
              } else {
                address.latitude = null;
                address.longitude = null;
              }
            },
          }
        });
        this.model = { 
          ...data, 
          region_id: 
          data.region_id ? data.region_id.toString() : null,
          farms: farmResponses,
          ...addresses
        };
        // this.model.farms = []
        return response;
      } catch (error) {
        this.failedAlert(error);
      } finally {
        this.loading = false;
      }
    },
    update(value) {
      if(value.type.indexOf('farmer') === -1){
        delete value.farms
      }

      value.addresses = [];

      ['lcs', 'brs', 'processing'].forEach((customer_type) => {
        if(value.type.indexOf(customer_type) !== -1){
          value.addresses.push({
            ...value?.[customer_type],
            type: customer_type,
          })
        }
      });

      return this.$axios.put(`/customers/${this.$route.params.key}`, value);
    },
    delete() {
      return this.$axios.delete(`/customers/${this.$route.params.key}`);
    }
  }

}
</script>
